export let life = {
  created() {
    // console.log(this.footer)
    // console.log(this.$slots.footer)
  }
};
export let event = {
  closeDialog() {
    this.$emit('update:dialogVisible', false);
    this.methods('resetInput');
    this.$emit('close')
  },
  async clickSubmit() {
    let isOk = await this.methods('checkForm');
    // console.log(isOk)
    if (isOk) {
      this.$emit('submit');
    }
  },
};
